<template>
  <transition name="global-loading-fade">
    <div v-if="visible" class="global-loading">
      <div class="global-loading__content">
        <div class="global-loading__spinner">
          <span class="global-loading__ring"></span>
          <span class="global-loading__ring global-loading__ring--delay"></span>
        </div>
        <p class="global-loading__text">Loading...</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalLoading',
  computed: {
    visible() {
      return this.$store.state.loading
    },
  },
}
</script>

<style lang="scss" scoped>
.global-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: hsla(0, 0%, 100%, 0.75);
  backdrop-filter: blur(2px);
}

.global-loading__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.global-loading__spinner {
  position: relative;
  width: 52px;
  height: 52px;
}

.global-loading__ring {
  position: absolute;
  inset: 0;
  border: 3px solid transparent;
  border-top-color: #f6b010;
  border-right-color: #b299f0;
  border-radius: 50%;
  animation: global-loading-spin 0.9s linear infinite;
}

.global-loading__ring--delay {
  inset: 8px;
  border-top-color: #b299f0;
  border-right-color: #f6b010;
  animation-duration: 1.2s;
  animation-direction: reverse;
}

.global-loading__text {
  font-size: 14px;
  color: #555;
  letter-spacing: 0.5px;
}

.global-loading-fade-enter-active,
.global-loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.global-loading-fade-enter,
.global-loading-fade-leave-to {
  opacity: 0;
}

@keyframes global-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
